module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-756-min.509bede0.jpg";